import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-554b74ff"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { id: "pdf" }, null, -1); });
var _hoisted_4 = {
    key: 0,
    class: "btn-box"
};
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("审核不通过");
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { style: { display: 'inline-block', width: '1rem' } }, null, -1); });
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("审核通过");
var _hoisted_8 = { class: "overlay-wrapper" };
var _hoisted_9 = {
    key: 0,
    style: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: '#fff',
        zIndex: 100,
    }
};
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { cheekReport } from "@/api";
import { Toast, Dialog } from "vant";
import AuditReject from "@/components/doctor/auditReject.vue";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default /*#__PURE__*/ _defineComponent({
    __name: 'orderDetail',
    setup: function (__props) {
        var router = useRouter();
        var route = useRoute();
        var loadingVisible = ref(true);
        var passBtnLoading = ref(false);
        var handlePass = function () {
            Dialog.confirm({
                message: "您确定审核通过此报告？",
                // confirmButtonText: "继续申请",
                confirmButtonColor: "#3DABA4",
            })
                .then(function () {
                passBtnLoading.value = true;
                // on confirm
                cheekReport({
                    reportStatus: 2,
                    reportId: route.query.reportId,
                })
                    .finally(function () { return (passBtnLoading.value = false); })
                    .then(function (res) {
                    if (res.code === 200) {
                        Toast("审核通过！");
                        router.go(-1);
                    }
                    else {
                        Toast(res.message);
                    }
                });
            })
                .catch(function () {
                // on cancel
            });
        };
        var rejectBtnLoading = ref(false);
        var handleReject = function (lastRejectReason) {
            rejectBtnLoading.value = true;
            cheekReport({
                reportStatus: 3,
                reportId: route.query.reportId,
                lastRejectReason: lastRejectReason,
            })
                .finally(function () { return (rejectBtnLoading.value = false); })
                .then(function (res) {
                if (res.code === 200) {
                    Toast("已拒绝！");
                    router.go(-1);
                }
                else {
                    Toast(res.message);
                }
            });
        };
        var show = ref(false);
        var pdfh5 = ref();
        onMounted(function () {
            pdfh5.value = new Pdfh5("#pdf", {
                pdfurl: route.query.reportUrl,
                // lazy: true,
                cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/",
            });
            pdfh5.value.on("complete", function () {
                console.log("加载完成");
                loadingVisible.value = false;
            });
        });
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "样本报告详情",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).push('/doctor-list')); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (_unref(route).query.reportStatus === '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_van_button, {
                                round: "",
                                color: "#ff0000",
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (show.value = true); }),
                                loading: rejectBtnLoading.value
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_5
                                ]; }),
                                _: 1
                            }, 8, ["loading"]),
                            _hoisted_6,
                            _createVNode(_component_van_button, {
                                round: "",
                                color: "#3DABA4",
                                onClick: handlePass,
                                loading: passBtnLoading.value
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_7
                                ]; }),
                                _: 1
                            }, 8, ["loading"])
                        ]))
                        : _createCommentVNode("", true)
                ], 512), [
                    [_vShow, !show.value]
                ]),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"]),
                (show.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(AuditReject, {
                            onOk: handleReject,
                            onCancel: _cache[2] || (_cache[2] = function ($event) { return (show.value = false); })
                        })
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
